import { render, staticRenderFns } from "./ManageSelectors.vue?vue&type=template&id=feaf3182&"
import script from "./ManageSelectors.vue?vue&type=script&lang=ts&"
export * from "./ManageSelectors.vue?vue&type=script&lang=ts&"
import style0 from "./ManageSelectors.vue?vue&type=style&index=0&id=feaf3182&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports